import React from "react";

// Renderizado dentro do cartão, onde a tabela estaria: mantém a moldura e
// oferece recuperação — a tela antiga só mostrava o texto do erro e obrigava
// o usuário a recarregar a página.
function ErrorState({ title, message, onRetry }) {
  return (
    <div className="card-state">
      <div className="alert alert-error" role="alert">
        <div className="alert-icon" aria-hidden="true">
          !
        </div>
        <div>
          <b className="alert-title">{title}</b>
          {message}
        </div>
      </div>
      <button className="btn btn-secondary" type="button" onClick={onRetry}>
        Tentar novamente
      </button>
    </div>
  );
}

export default ErrorState;
